import * as t from "./type";

import { getContent } from "../../../services/contentful";

export const primaryTextButton = x => ({
  type: t.PRIMARY_TEXT_BUTTON,
  payload: x
});
export const secondaryTextButton = x => ({
  type: t.SECONDARY_TEXT_BUTTON,
  payload: x
});
export const landingOrder = x => ({ type: t.LANDING_ORDER, payload: x });
export const hasCoupon = x => ({ type: t.HAS_COUPON, payload: x });
export const couponCardTitle = x => ({ type: t.COUPON_CARD_TITLE, payload: x });
export const couponCardAuxText = x => ({
  type: t.COUPON_CARD_AUX_TEXT,
  payload: x
});
export const couponCardBgColor = x => ({
  type: t.COUPON_CARD_BG_COLOR,
  payload: x
});
export const couponCardPrimaryBtnColor = x => ({
  type: t.COUPON_CARD_PRIMARY_BUTTON_COLOR,
  payload: x
});
export const couponCardPrimaryBtnTextColor = x => ({
  type: t.COUPON_CARD_PRIMARY_BUTTON_TEXT_COLOR,
  payload: x
});
export const especificsCoupons = x => ({ type: t.ESPECIFICS_COUPONS, payload: x });
export const landingTitle = x => ({ type: t.LANDING_TITLE, payload: x });
export const landingName = x => ({ type: t.LANDING_NAME, payload: x });
export const isGeneric = x => ({ type: t.IS_GENERIC, payload: x });
export const partnerLogo = x => ({ type: t.PARTNER_LOGO, payload: x });
export const veloeLogo = x => ({ type: t.VELOE_LOGO, payload: x });
export const bannerPrimaryText = x => ({
  type: t.BANNER_PRIMARY_TEXT,
  payload: x
});
export const bannerSecondaryText = x => ({
  type: t.BANNER_SECONDARY_TEXT,
  payload: x
});
export const bannerBgImage = x => ({ type: t.BANNER_BG_IMAGE, payload: x });
export const hasPrimmaryBtn = x => ({ type: t.HAS_PRIMMARY_BTN, payload: x });
export const hasSecondaryBtn = x => ({ type: t.HAS_SECONDARY_BTN, payload: x });
export const secondaryBorderBtn = x => ({
  type: t.SECONDARY_BORDER_BTN,
  payload: x
});
export const bannerTitle = x => ({ type: t.BANNER_TITULO, payload: x });
export const bannerTitleColor = x => ({ type: t.BANNER_TITLE_COLOR, payload: x });
export const bannerMessage = x => ({ type: t.BANNER_MESSAGE, payload: x });
export const bannerMessageColor = x => ({ type: t.BANNER_MESSAGE_COLOR, payload: x });
export const bannerPrimaryBtnColor = x => ({
  type: t.BANNER_BUTTON_PRIMARY_COLOR,
  payload: x
});
export const bannerPrimaryBtnTextColor = x => ({
  type: t.BANNER_BUTTON_SECONDARY_COLOR,
  payload: x
});
export const bannerSecondaryBtnColor = x => ({
  type: t.BANNER_BUTTON_PRIMARY_TEXT_COLOR,
  payload: x
});
export const bannerSecondaryBtnTextColor = x => ({
  type: t.BANNER_BUTTON_SECONDARY_TEXT_COLOR,
  payload: x
});
export const parking = x => ({ type: t.PARKING, payload: x });

export const tolls = x => ({ type: t.TOLLS, payload: x });
export const parkingAndToll = x => ({ type: t.PARKING_AND_TOLL, payload: x });
export const regulamento = x => ({ type: t.REGULAMENTO, payload: x });
export const simpleSectionBgColor = x => ({
  type: t.SIMPLE_SECTION_BACKGROUND_COLOR,
  payload: x
});
export const simpleSectionDescription = x => ({
  type: t.SIMPLE_SECTION_DESCRIPTION,
  payload: x
});
export const simpleSectionImage = x => ({
  type: t.SIMPLE_SECTION_IMAGE,
  payload: x
});
export const simpleSectionTitle = x => ({
  type: t.SIMPLE_SECTION_TITLE,
  payload: x
});
export const simpleSectionTextColor = x => ({
  type: t.SIMPLE_SECTION_TEXT_COLOR,
  payload: x
})
export const mapTitle = x => ({ type: t.MAP_TITLE, payload: x });
export const mapDescriptions = x => ({ type: t.MAP_DESCRIPTION, payload: x });
export const stepsBgColor = x => ({ type: t.STEPS_BG_COLOR, payload: x });
export const steps = x => ({ type: t.STEPS, payload: x });
export const stepsTitle = x => ({ type: t.STEPS_TITLE, payload: x });
export const stepsFirstArrow = x => ({ type: t.STEPS_FIRST_ARROW, payload: x});
export const stepsSecondArrow = x => ({ type: t.STEPS_SECOND_ARROW, payload: x});

export const doubleSectionBgTopColor = x => ({
  type: t.DOUBLE_SECTION_BG_TOP_COLOR,
  payload: x
});

export const doubleSectionDescriptionTop = x => ({
  type: t.DOUBLE_SECTION_DESCRIPTION_TOP,
  payload: x
});

export const doubleSectionImageTop = x => ({
  type: t.DOUBLE_SECTION_IMAGE_TOP,
  payload: x
});
export const doubleSectionTitleTop = x => ({
  type: t.DOUBLE_SECTION_TITLE_TOP,
  payload: x
});
export const doubleSectionTextColor = x => ({
  type: t.DOUBLE_SECTION_TEXT_COLOR,
  payload: x
});

export const tagTitle = x => ({
  type: t.TAG_TITLE,
  payload: x
});
export const tagTitleColor = x => ({
  type: t.TAG_TITLE_COLOR,
  payload: x
});
export const tagImg = x => ({
  type: t.TAG_IMG,
  payload: x
});
export const tagTextButton = x => ({
  type: t.TAG_TEXT_BUTTON,
  payload: x
});
export const tagColorButton = x => ({
  type: t.TAG_COLOR_BUTTON,
  payload: x
});
export const tagColorTextButton = x => ({
  type: t.TAG_COLOR_TEXT_BUTTON,
  payload: x
});
export const tagBgColor = x => ({
  type: t.TAG_BG_COLOR,
  payload: x
});

export const getComponent = () => async (dispatch, getState) => {
  await getContent().then((data) => {
    // console.log(data);
    var arr = [];
    data.fields.landingSections.map((x, i) => arr.push({ value: x.sys.contentType.sys.id, index: i }));

    //LANDING OPTIONS
    dispatch(landingOrder(arr));
    dispatch(landingTitle(data.fields.landingTitle));
    dispatch(landingName(data.fields.nomeDaLanding));
    dispatch(isGeneric(data.fields.isGeneric));
    dispatch(especificsCoupons(data.fields.especificsCoupons));
    arr.map((x) => {
      if (x.value === "landingCouponCard") {
        //COUPON OPTIONS
        dispatch(
          primaryTextButton(
            data.fields.landingSections[x.index].fields.textoDoBotaoPrimario
          )
        );
        dispatch(
          secondaryTextButton(
            data.fields.landingSections[x.index].fields.textoDoBotaoSecundario
          )
        );
        dispatch(hasCoupon(data.fields.hasCoupon));
        dispatch(
          couponCardTitle(
            data.fields.landingSections[x.index].fields.couponCardTitle
          )
        );
        dispatch(
          couponCardAuxText(
            data.fields.landingSections[x.index].fields.couponCardAuxText
          )
        );
        dispatch(
          couponCardBgColor(
            data.fields.landingSections[x.index].fields.couponCardBgColor
          )
        );
        dispatch(
          couponCardPrimaryBtnColor(
            data.fields.landingSections[x.index].fields
              .couponCardPrimaryButtonColor
          )
        );
        dispatch(
          couponCardPrimaryBtnTextColor(
            data.fields.landingSections[x.index].fields
              .couponCardPrimaryButtonTextColor
          )
        );
      }
      if (x.value === "landingNav") {
        //NAV OPTIONS
        dispatch(
          partnerLogo(
            data.fields.landingSections[x.index].fields.parceiroLogo
              ? data.fields.landingSections[x.index].fields.parceiroLogo.fields
                  .file.url
              : null
          )
        );
        dispatch(
          veloeLogo(
            data.fields.landingSections[x.index].fields.veloeLogo.fields.file
              .url
          )
        );
      }
      if (x.value === "landingHeader") {
        //BANNER HEADER OPTIONS
        dispatch(
          bannerPrimaryText(
            data.fields.landingSections[x.index].fields.PrimaryButtonText
          )
        );
        dispatch(
          hasPrimmaryBtn(
            data.fields.landingSections[x.index].fields.hasPrimmaryBtn
          )
        );
        dispatch(
          hasSecondaryBtn(
            data.fields.landingSections[x.index].fields.hasSecondaryBtn
          )
        );
        dispatch(
          secondaryBorderBtn(
            data.fields.landingSections[x.index].fields.secondaryBtnBorder
          )
        );
        dispatch(
          bannerSecondaryText(
            data.fields.landingSections[x.index].fields.secondaryButtonText
          )
        );
        dispatch(
          bannerBgImage(
            data.fields.landingSections[x.index].fields.backgroundImagem.fields
              .file.url
          )
        );
        dispatch(
          bannerTitle(data.fields.landingSections[x.index].fields.landingTitulo)
        );
        dispatch(
          bannerTitleColor(data.fields.landingSections[x.index].fields.bannerTitleColor)
        );
        dispatch(
          bannerMessage(
            data.fields.landingSections[x.index].fields.mensagemBanner
          )
        );
        dispatch(
          bannerMessageColor(
            data.fields.landingSections[x.index].fields.bannerMessageColor
          )
        );
        dispatch(
          bannerPrimaryBtnTextColor(
            data.fields.landingSections[x.index].fields.primaryColorButton
          )
        );
        dispatch(
          bannerPrimaryBtnColor(
            data.fields.landingSections[x.index].fields.primaryButtonTextColor
          )
        );
        dispatch(
          bannerSecondaryBtnColor(
            data.fields.landingSections[x.index].fields.secondaryButtonColor
          )
        );
        dispatch(
          bannerSecondaryBtnTextColor(
            data.fields.landingSections[x.index].fields.secondaryButtonTextColor
          )
        );
      }
      if (x.value === "landingDefaultPromo") {
        //DEFAULT PROMO OPTIONS
        dispatch(
          parking(data.fields.landingSections[x.index].fields.pedagios.sys.id)
        );
        dispatch(
          tolls(
            data.fields.landingSections[x.index].fields.estacionamentos.sys.id
          )
        );
        dispatch(
          parkingAndToll(
            data.fields.landingSections[x.index].fields.pedagiosEstacionamentos
              .sys.id
          )
        );
        dispatch(
          regulamento(data.fields.landingSections[x.index].fields.regulamento)
        );
      }
      if (x.value === "landingSimpleSection") {
        //SIMPLE SECTION OPTIONS
        dispatch(
          simpleSectionBgColor(
            data.fields.landingSections[x.index].fields.background
          )
        );
        dispatch(
          simpleSectionDescription(
            data.fields.landingSections[x.index].fields.description
          )
        );
        dispatch(
          simpleSectionImage(
            data.fields.landingSections[x.index].fields.image.fields.file.url
          )
        );
        dispatch(
          simpleSectionTitle(data.fields.landingSections[x.index].fields.title)
        );
        dispatch(
          simpleSectionTextColor(data.fields.landingSections[x.index].fields.textColor)
        )
      }
      if (x.value === "landingMapa") {
        //MAP OPTIONS
        dispatch(mapTitle(data.fields.landingSections[x.index].fields.title));
        dispatch(
          mapDescriptions(
            data.fields.landingSections[x.index].fields.description
          )
        );
      }
      if (x.value === "landingStepperSection") {
        //STEPS OPTIONS
        dispatch(
          stepsBgColor(
            data.fields.landingSections[x.index].fields.backgroundColor
          )
        );
        dispatch(
          steps(
            data.fields.landingSections[x.index].fields.steps.map(step => {
              return step.sys.id;
            })
          )
        );
        dispatch(stepsTitle(data.fields.landingSections[x.index].fields.title));
        dispatch(stepsFirstArrow(
          data.fields.landingSections[x.index].fields.firstArrow.fields.file.url
        )
        )
        dispatch(stepsSecondArrow(
            data.fields.landingSections[x.index].fields.secondArrow.fields.file.url
          )
        )
      }
      
      if (x.value === "landingDoubleSection") {
        //DOUBLE SECTION OPTION
        dispatch(
          doubleSectionBgTopColor(
            data.fields.landingSections[x.index].fields.corDeFundoTopo
          )
        );
        dispatch(
          doubleSectionDescriptionTop(
            data.fields.landingSections[x.index].fields.descricaoTopo
          )
        );
        dispatch(
          doubleSectionTitleTop(
            data.fields.landingSections[x.index].fields.tituloTopo
          )
        );
        dispatch(
          doubleSectionImageTop(
            data.fields.landingSections[x.index].fields.imagemTopo.fields.file
              .url
          )
        );
        dispatch(
          doubleSectionTextColor(
            data.fields.landingSections[x.index].fields.textColor
          )
        );
      }
      if (x.value === "landingSecaoTagVeloe") {
        dispatch(tagTitle(data.fields.landingSections[x.index].fields.titulo));
        dispatch(tagTitleColor(data.fields.landingSections[x.index].fields.titleColor));
        dispatch(
          tagImg(
            data.fields.landingSections[x.index].fields.tag.fields.file.url
          )
        );
        dispatch(
          tagTextButton(data.fields.landingSections[x.index].fields.botao)
        );
        dispatch(
          tagColorButton(data.fields.landingSections[x.index].fields.corDoBotao)
        );
        dispatch(
          tagColorTextButton(
            data.fields.landingSections[x.index].fields.corDoTextoDoBoto
          )
        );
        dispatch(
          tagBgColor(data.fields.landingSections[x.index].fields.corDeFundo)
        );
      }
      return true;
    });
  });
};
